
import atlas from "@/components/atlas.vue";
import { eventUploadMixin } from '@/plugins/hwtag/events';
export default {
  mixins: [eventUploadMixin],
  data() {
    return {
      scrollTop: 0,
      currentPage: 1,
      source: "",
      bannerH: 0,
      headerH: 0,
      imgUrl: 'https://resource.xp-pen.com/img/Contest/CreativeContest_JP/',
      imgUrl_kr: 'https://resource.xp-pen.com/img/Contest/paintingContest_KR/',
      nav: 3,
      navTop: 0,
      navList: ['대회소개', '대회안내', '작품 컬렉션', '수상작품'],
      showPop: false,
      popImg: ''
    };
  },
  head() {
    // 优化seo：动态设置title，keywords 和 description
    return {
      title: "나의 아이돌 엑스피펜 2023년연말 드로잉 대회",
      meta: [
        {
          name: "keywords",
          content: "XPPen, 나의, 아이돌,엑스피펜, 2023년연말,드로잉",
        },
        {
          hid: "description",
          name: "names",
          content: "이번 공모전의 주제인 '나의 아이돌'은 참가자가 좋아하는 가수, 배우, 모델 등 연예인, 인플루언서, 작가, 과학은 참가자가 좋아하는 가수, 배우, 모델 등 연예인, 인플루언서, 작가, 과학자 심지어 일반인 등 다양한 분야 중에서 그리고 싶은 인물을 선정할 수 있습니다.",
        },
      ],
    };
  },
  components: { atlas },
  computed: {},
  mounted() {
    this.bannerH = this.$refs.bannerHeight.offsetHeight;
    const navEl = document.getElementsByTagName("nav")[0];
    const navStyle = window.getComputedStyle(navEl);
    const navMarginTop = parseFloat(navStyle.marginTop);
    const headerOffsetH = document.getElementsByTagName("header")[0].offsetHeight;
    this.navTop = headerOffsetH - navMarginTop;
    this.headerH = headerOffsetH;
    this.parametricWork();
    window.addEventListener('scroll', this.handleScroll, true);
  },
  methods: {
    // 作品方法
    async parametricWork(type, page = 1) {
      let res = await this.$global.parametricWork({ "activityId": 38, "page": page, "award": 0 })
      console.log(res);
      // res.code = '200' ? (this.source = res.result) : []
      this.source = res
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val
      this.parametricWork(28, this.currentPage)
    },
    // 滚动方法
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    },
    // nav
    handleScrollTo(id) {
      this.nav = id;
    },
    showPopChange(imgUrl) {
      this.popImg = imgUrl;
      this.showPop = true;

    },
    closeBtn() {
      this.showPop = false;
    }
  },
};
